import { has } from 'lodash';

export const isAccountReady = (account) => !!account?.funds?.length && !!account?.deliveryLocations?.length;

export const hasReadyAccount = (userAccounts = []) =>
  userAccounts.some((userAccount) => isAccountReady(userAccount?.account ?? userAccount));

export function formatFundValueToString(value) {
  if (typeof value === 'string') {
    return value;
  }
  if (has(value, 'kfsChartCode')) {
    return `${value.kfsChartCode} ${value.kfsAcctNumber}`;
  }
  if (has(value, 'budgetCode')) {
    return `${value.budgetCode} ${value.accountCode}-${value.fundCode}`;
  }
  if (has(value, 'speedType')) {
    return `${`${value.businessUnit} ` || ''}${value.speedType || ''}`;
  }
  if (has(value, 'businessUnit')) {
    return `${value.businessUnit}${value.account || '*****'}${value.fund}${value.departmentId}${value.project}${
      value.activityPeriod || '**'
    }${value.function || '**'}${value.flexField || '******'}`;
  }
  return '';
}

export const SUBLOCATION_AVAILABILITY = {
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  NONE_CONFIGURED: 'NONE_CONFIGURED',
  ALL_USED: 'ALL_USED',
  AVAILABLE: 'AVAILABLE',
};

/**
 * PI-1545: delivery to an inventory account needs a chemical sublocation (PI-244), but a new
 * group has none until someone creates one in Chemicals. Tells the delivery-location form why its
 * dropdowns are empty so it can point the user to the fix instead of a dead end.
 */
export function getSublocationAvailability({ loading, error, sublocations, usedSublocationIds = [] }) {
  if (loading) {
    return SUBLOCATION_AVAILABILITY.LOADING;
  }
  if (error) {
    return SUBLOCATION_AVAILABILITY.ERROR;
  }
  const all = sublocations || [];
  if (all.length === 0) {
    return SUBLOCATION_AVAILABILITY.NONE_CONFIGURED;
  }
  return all.some((item) => !usedSublocationIds.includes(item._id))
    ? SUBLOCATION_AVAILABILITY.AVAILABLE
    : SUBLOCATION_AVAILABILITY.ALL_USED;
}
